module.exports = __webpack_public_path__ + "static/dashboard_donate_tmp@2x-c33fe98e54c35d2c8c67c29e698eaa16.png";